<div class="menu-my-membership">
    <!-- Subpágina: carnet digital del abono -->
    <router-outlet></router-outlet>

    <ng-container *ngIf="!carnetOpen">

    <h2 class="section-title">Mis abonos</h2>
    <p class="section-intro m-0">Tus abonos de temporada y el carné digital con el que entras.</p>

    <div class="content">
            <div class="empty-content" *ngIf="!loaded">
                <i class="fa-light fa-spinner fa-spin"></i>
                <p>Cargando tus abonos...</p>
            </div>

            <div class="empty-content" *ngIf="loaded && loadError">
                <i class="fa-light fa-circle-exclamation"></i>
                <p>No hemos podido cargar tus abonos. Vuelve a intentarlo en unos minutos.</p>
            </div>

            <div class="abonos-grid" *ngIf="loaded && !loadError && abonos.length">
                <div class="abono-card" *ngFor="let abono of abonos" [class.pending]="!isPaid(abono.seasonPass)"
                    [class.clickable]="isPaid(abono.seasonPass)" (click)="openQr(abono.seasonPass)">
                    <div class="abono-card-image">
                        <span class="abono-badge">
                            <i class="fa-solid fa-circle"></i>
                            {{ abono.seasonPass.status?.name || 'Pendiente' }}
                        </span>
                        <img *ngIf="abono.image" class="abono-card-photo" [src]="abono.image"
                            [alt]="abono.seasonPass.season?.name || 'Abono de temporada'"
                            (error)="onImageError(abono)">
                        <i class="abono-card-placeholder fa-light fa-shield-halved" *ngIf="!abono.image"></i>
                    </div>

                    <div class="abono-card-body">
                        <span class="abono-company" *ngIf="abono.seasonPass.season?.company?.name">
                            {{ abono.seasonPass.season?.company?.name }}
                        </span>
                        <div class="abono-card-header">
                            <h3 class="abono-card-title">{{ abono.seasonPass.season?.name || 'Abono de temporada' }}</h3>
                            <span class="abono-chip" *ngIf="abono.seasonPass.category?.name">
                                {{ abono.seasonPass.category?.name }}
                            </span>
                        </div>

                        <div class="abono-data">
                            <div class="abono-data-item">
                                <span class="abono-label">Nº de abonado</span>
                                <p class="abono-value">{{ abono.seasonPass.member_number }}</p>
                            </div>

                            <!-- "Ubicación" y no "Butaca": el valor lleva el nivel
                                 delante, que es lo que hace que la fila y la butaca
                                 signifiquen algo. -->
                            <div class="abono-data-item" *ngIf="seatDisplay(abono.seasonPass)">
                                <span class="abono-label">Ubicación</span>
                                <p class="abono-value">{{ seatDisplay(abono.seasonPass) }}</p>
                            </div>
                        </div>

                        <div class="abono-card-footer">
                            <div class="abono-price" *ngIf="abono.price !== null && showPrice(abono.seasonPass)">
                                <span class="abono-label">Importe</span>
                                <p class="abono-price-value">
                                    <span class="abono-price-from" *ngIf="abono.hasSeveralPrices">Desde </span>{{ abono.price | number: '1.2-2' }} €
                                </p>
                            </div>

                            <p class="abono-card-status" *ngIf="!isPaid(abono.seasonPass)">
                                <i class="fa-light fa-clock"></i> Pendiente de confirmar el pago
                            </p>

                            <button type="button" class="abono-pay-btn" *ngIf="!isPaid(abono.seasonPass)" (click)="goToCheckout(abono.seasonPass); $event.stopPropagation()">
                                Completar pago <i class="fa-light fa-arrow-right"></i>
                            </button>

                            <button type="button" class="abono-pay-btn" *ngIf="isPaid(abono.seasonPass)" (click)="openQr(abono.seasonPass)">
                                Ver carnet digital <i class="fa-light fa-qrcode"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="empty-content" *ngIf="loaded && !loadError && !abonos.length">
                <i class="fa-light fa-id-card"></i>
                <p>Aún no tienes ningún abono de temporada</p>
            </div>
    </div>
    </ng-container>
</div>
